import React from 'react';
import { motion } from 'framer-motion';
import '../Styles/Hero.css';
import MyPic from '../images/nadeem.webp';

const Herosection = () => {
  return (
    <div>
      <section className="hero" id="hero">
        <motion.div
          className="hero-text"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
        >
          
          <h1>Nadeem</h1>
          <div className="center-text">
            <h5>WEB DEVELOPER</h5>
          </div>
          <h1>Ashraf</h1>
          {/* Image at the bottom */}
        </motion.div>

        <img 
            src= {MyPic}
            alt="Hero Image" 
            className="hero-image" 
          />
      </section>  
      
    </div> 
  );
};

export default Herosection;
